export const dashboardWebsiteUrl = "https://www.openproject.org/collaboration-software-features/dashboards/";
